/** Meta app with WhatsApp / Embedded Signup (prod business app). */
const DEFAULT_WHATSAPP_FACEBOOK_APP_ID = "400801087311687";

export type WhatsAppConnectionMode = "api_only" | "coexistence";

export const WHATSAPP_FACEBOOK_APP_ID =
  process.env.REACT_APP_WHATSAPP_FACEBOOK_APP_ID ||
  DEFAULT_WHATSAPP_FACEBOOK_APP_ID;

export const WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID =
  process.env.REACT_APP_WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID ||
  "1138875521271939";

/** Optional separate config in Meta for coexistence onboarding. */
export const WHATSAPP_COEXISTENCE_SIGNUP_CONFIG_ID =
  process.env.REACT_APP_WHATSAPP_COEXISTENCE_SIGNUP_CONFIG_ID ||
  WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID;

export const WHATSAPP_ENVIROMENTS = {
  redirectUrl: process.env.REACT_APP_WEB_URL,
};
